<template>
  <div class="listing">
    <div class="row mb-2">
      <div class="col-md-7">
        <h2 class="bold">{{ $i18n.t($route.meta.listing) }}</h2>
      </div>
      <div class="col-md-5 text-right">
        <b-link
          class="btn btn-secondary"
          href="javascript:void(0)"
          @click="showFilterFt"
          v-if="can_filter"
          ><span v-if="!showFilter">{{ $i18n.t("Filtrer les résultats") }}</span
          ><span v-else>{{ $i18n.t("Fermer les filtres") }}</span></b-link
        >
        <b-link
          class="btn btn-secondary ml-2"
          href="javascript:void(0)"
          @click="get_data(-1)"
          v-if="can_export"
          ><span
            v-if="!exportProgress"
            class="material-icons"
            style="font-size: 20px;margin-bottom: -5px;position: relative;top: 2px;"
            >file_download</span
          ><span v-else>{{ $i18n.t("Export en cours") }} ...</span></b-link
        >
        <b-link
          class="btn btn-gold ml-2"
          href="javascript:void(0)"
          @click="commander('')"
          v-if="$route.meta.btn != '' && can_create_dossier"
          >{{ $i18n.t($route.meta.btn) }}</b-link
        >
      </div>
    </div>
    <div
      :class="'mb-2 mt-2 bg-blue ' + (showFilter ? '' : 'hide')"
      v-if="can_filter"
    >
      <div class="row searchFilter mb-5">
        <div class="col-md-4 mb-2">
          <DynField
            name="reference_client"
            v-model="forms.reference"
            @load="maj_field_reference"
          ></DynField>
        </div>
        <div class="col-md-4 mb-2">
          <label>{{ $i18n.t("Période personnalisée") }}</label>
          <div class="row">
            <div class="col-md-6">
              <b-input-group class="mb-3">
                <b-form-input
                  id="forms-debut"
                  v-model="forms.periode.debut"
                  type="text"
                  :placeholder="$t('Date de début')"
                  autocomplete="off"
                  v-mask="$t('####-##-##')"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="forms.periode.debut_dp"
                    button-only
                    right
                    :locale="$t('fr-FR')"
                    aria-controls="forms-debut"
                    @context="onContextDate('debut')"
                    :labelNoDateSelected="$t('Aucune date sélectionnée')"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div class="col-md-6">
              <b-input-group class="mb-3">
                <b-form-input
                  id="forms-fin"
                  v-model="forms.periode.fin"
                  type="text"
                  :placeholder="$t('Date de fin')"
                  autocomplete="off"
                  v-mask="$t('####-##-##')"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="forms.periode.fin_dp"
                    button-only
                    right
                    :locale="$t('fr-FR')"
                    aria-controls="forms-fin"
                    @context="onContextDate('fin')"
                    :labelNoDateSelected="$t('Aucune date sélectionnée')"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-2" v-if="this.$route.path != '/dataroom'">
          <label>{{ $t("Période") }}</label>
          <b-form-select
            v-model="periode"
            :options="date"
            text-field="label"
            @change="predefined_date(periode)"
            class="form-control"
          ></b-form-select>
        </div>
        <div class="col-md-4 mb-2">
          <label>{{ $i18n.t("Collaborateur") }}</label>
          <multiselect
            :showNoOptions="false"
            :showNoResults="false"
            v-model="forms.gestionnaires"
            :options="options.gestionnaires"
            :placeholder="$t('Sélectionnez un ou plusieurs collaborateur(s)')"
            label="name"
            track-by="name"
            :multiple="true"
            :selectLabel="$t('Entrer pour valider')"
            :selectedLabel="$t('Ajouté')"
            :close-on-select="false"
            :clear-on-select="false"
          ></multiselect>
        </div>
        <div class="col-md-4 mb-2">
          <label>{{ $i18n.t("Organisation") }}</label>
          <multiselect
            :showNoOptions="false"
            :showNoResults="false"
            v-model="forms.organisations"
            :options="options.organisations"
            :placeholder="$t('Sélectionnez une ou plusieurs organisation(s)')"
            label="name"
            track-by="name"
            :multiple="true"
            :selectLabel="$t('Entrer pour valider')"
            :selectedLabel="$t('Ajouté')"
            :close-on-select="false"
            :clear-on-select="false"
          ></multiselect>
        </div>
        <div class="col-md-4 mb-2">
          <label>{{ $i18n.t("Service") }}</label>
          <multiselect
            :showNoOptions="false"
            :showNoResults="false"
            v-model="forms.services"
            :options="options.services"
            :placeholder="$t('Sélectionnez un ou plusieurs service(s)')"
            label="name"
            track-by="name"
            :multiple="true"
            :selectLabel="$t('Entrer pour valider')"
            :selectedLabel="$t('Ajouté')"
            :close-on-select="false"
            :clear-on-select="false"
          ></multiselect>
        </div>
        <div class="col-md-4 mb-2" v-if="this.$route.path == '/evaluations'">
          <label>{{ $i18n.t("Type de bien") }}</label>
          <multiselect
            :showNoOptions="false"
            :showNoResults="false"
            v-model="forms.types_bien"
            :options="options.types_bien"
            :placeholder="$t('Sélectionnez un ou plusieurs type(s) de bien')"
            label="name"
            track-by="name"
            :multiple="true"
            :selectLabel="$t('Entrer pour valider')"
            :selectedLabel="$t('Ajouté')"
            :close-on-select="false"
            :clear-on-select="false"
          ></multiselect>
        </div>
        <div class="col-md-4 mb-2" v-if="this.$route.path != '/evaluations'">
          <label>{{ $t("Statut(s)") }}</label>
          <multiselect
            :showNoOptions="false"
            :showNoResults="false"
            v-model="forms.statuts"
            :options="options.statuts"
            :placeholder="$t('Sélectionnez un ou plusieurs statut(s)')"
            label="name"
            track-by="name"
            :multiple="true"
            :selectLabel="$t('Entrer pour valider')"
            :selectedLabel="$t('Ajouté')"
            :close-on-select="false"
            :clear-on-select="false"
          ></multiselect>
        </div>
        <div class="col-md-4 mb-2" v-if="this.$route.path == '/'">
          <label>{{ $t("Prestation(s)") }}</label>
          <multiselect
            :showNoOptions="false"
            :showNoResults="false"
            v-model="forms.prestations"
            :options="options.prestations"
            :placeholder="$t('Sélectionnez une ou plusieurs prestation(s)')"
            label="text"
            track-by="text"
            :multiple="true"
            :selectLabel="$t('Entrer pour valider')"
            :selectedLabel="$t('Ajouté')"
            :close-on-select="false"
            :clear-on-select="false"
          ></multiselect>
        </div>
        <div
          class="col-md-4 mb-2 sliderRange"
          v-if="this.$route.path != '/dataroom'"
        >
          <label>{{ $t("Estimation") }}</label>
          <div id="prix"></div>
          <p class="spanAbso mt-1">
            <span>
              <span
                v-if="!prixMinFocus"
                @click="
                  prixMinFocus = 1;
                  forms.prix[0] = forms.prix[0].replace('.00', '');
                "
                >{{ format_number(forms.prix[0]) }}</span
              >
              <b-form-input
                v-else
                @blur="
                  prixMinFocus = 0;
                  reset_nui();
                "
                type="number"
                v-model.number="forms.prix[0]"
                :min="datas_def.estimation_min"
                :max="forms.prix[1]"
                step="5"
                @keypress="isNumber($event)"
              ></b-form-input>
              {{ $t("€") }}
            </span>
            <span>
              <span
                v-if="prixMaxFocus != 1"
                @click="
                  prixMaxFocus = 1;
                  forms.prix[1] = forms.prix[1].replace('.00', '');
                "
                >{{ format_number(forms.prix[1]) }}</span
              >
              <b-form-input
                v-else
                @blur="
                  prixMaxFocus = 0;
                  reset_nui();
                "
                type="number"
                v-model.number="forms.prix[1]"
                :min="forms.prix[0]"
                :max="datas_def.estimation_max"
                step="5"
                @keypress="isNumber($event)"
              ></b-form-input>
              {{ $t("€") }}
            </span>
          </p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-primary btn-text btn-sm"
            @click="reset_data"
          >
            {{ $t("Réinitialiser") }}
          </button>
        </div>
        <div class="col-md-6 text-right">
          <button
            type="button"
            class="btn btn-outline-gold btn-sm"
            @click="get_data(1)"
          >
            {{ $t("Appliquer les filtres") }}
          </button>
        </div>
      </div>
    </div>
    <div class="bg-blue">
      <b-table
        id="my-table"
        striped
        hover
        :items="items"
        :fields="format_fields(fields)"
        :busy="isBusy"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
      >
        <div slot="table-busy" class="text-center text-gold my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("Chargement ...") }}</strong>
        </div>
        <template v-slot:empty="scope">
          <h4 class="text-center">{{ $t("Aucune donnée actuellement...") }}</h4>
        </template>
        <template v-slot:cell(prestation)="row">
          {{ trad_prestation(row.item.prestation) }}
        </template>
        <template v-slot:cell(adresse)="row">
          {{ trad_adresse(row.item.adresse) }}
        </template>
        <template v-slot:cell(type_de_bien)="row">
          <div
            class="text-center"
            v-html="trad_type(row.item.type_de_bien).replace(' - ', '<br/>')"
          ></div>
        </template>
        <template v-slot:cell(date)="row">
          {{ date_to_local(row.item.date) }}
        </template>
        <template v-slot:cell(date_depot)="row">
          {{ date_to_local(row.item.date_depot) }}
        </template>
        <template v-slot:cell(estimation)="row">
          <span class="hight"
            ><span
              class="badge py-1 px-2 badge-success"
              v-if="parseInt(row.item.estimation) == row.item.estimation"
              >{{ format_number(row.item.estimation) }} €</span
            ><span v-else>{{
              row.item.estimation.replace(
                "SPF interrogés",
                $t("SPF interrogés")
              )
            }}</span></span
          >
        </template>
        <template v-slot:cell(statut)="row">
          <span
            :class="
              'badge py-1 px-2 badge-' +
                (row.item.statut > 1
                  ? 'success'
                  : row.item.statut > 0
                  ? 'primary'
                  : 'warning')
            "
            >{{
              $t(
                row.item.statut > 1
                  ? "Finalisé"
                  : row.item.statut > 0
                  ? "En cours"
                  : row.item.statut == 0
                  ? "Nouveau"
                  : "En attente"
              )
            }}</span
          >
        </template>
        <template v-slot:cell(rapport)="row">
          <b-link
            size="sm"
            :class="
              'mr-1 rapportPDF ' +
                (row.item.statut > 1 ? 'disponible' : 'indisponible') +
                ' ' +
                (can_dl_dossier ? '' : 'hidden')
            "
            :data-id="row.item.id"
            :data-type="row.item.pf"
            :data-statut="row.item.statut"
            v-b-tooltip.hover
            :title="
              $t(
                'Rapport ' +
                  (row.item.statut > 1 ? 'disponible' : 'indisponible')
              )
            "
            ><span class="material-icons">folder_open</span></b-link
          >
          <b-link
            size="sm"
            :class="
              'mr-1 facturePDF' + ' ' + (can_read_facture ? '' : 'hidden')
            "
            :data-id="row.item.id"
            v-if="row.item.statut > 2"
            v-b-tooltip.hover
            :title="$t('Télécharger votre facture')"
            ><span class="material-icons">receipt_long</span></b-link
          >
          <b-link
            size="sm"
            @click="supprimer(row.item, items)"
            class="mr-1"
            v-if="can_delete && get_first_route() !== 'evaluations'"
            ><span class="material-icons">delete</span></b-link
          >
        </template>
        <template v-slot:cell(contact)="row">
          <b-link size="sm" class="mr-1" :href="'mailto:' + ste_email"></b-link>
        </template>
        <template v-slot:cell(actualisation)="row">
          <b-link size="sm" class="mr-1" :href="'mailto:' + ste_email"></b-link>
        </template>
        <template v-slot:cell(indice_confiance)="row">
          <Gauge :value="row.item.indice_confiance" />
        </template>
        <template v-slot:cell(fichiers)="row">
          <b-link
            size="sm"
            class="mr-1 badge"
            @click="get_doc('original', row.item.id)"
            :disabled="!row.item.original"
            >{{ $t("Original") }}</b-link
          >
          <b-link
            v-if="row.item.statut >= 0"
            size="sm"
            class="mr-1 badge"
            @click="get_doc('send', row.item.id)"
            :disabled="!row.item.send"
            >{{ $t("Envoyé") }}</b-link
          >
          <b-link
            v-if="row.item.statut >= 0"
            size="sm"
            class="badge"
            @click="get_doc('return', row.item.id)"
            :disabled="!row.item.return"
            >{{ $t("Retour") }}</b-link
          >
          <b-link
            v-if="row.item.statut < 0"
            size="sm"
            class="badge"
            @click="supprimer(row.item, items)"
            >{{ $t("Supprimer") }}</b-link
          >
          <b-link
            v-if="row.item.statut < 0"
            size="sm"
            class="badge"
            @click="$emit('continuer', row.item.id)"
            >{{ $t("Continuer la saisie") }}</b-link
          >
        </template>
      </b-table>
    </div>
    <div class="row mt-5">
      <div class="col-md-6 text-gray">
        {{ $t("Affichage de ") }} {{ items.length }}
        {{ $t("ligne" + (items.length > 1 ? "s" : "") + " sur") }}
        {{ totalItems }} {{ $t("disponible" + (totalItems > 1 ? "s" : "")) }}
      </div>
      <div class="col-md-6">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          aria-controls="my-table"
          align="right"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import multiselect from "vue-multiselect";
import VueInputMask from "v-mask";
import DynField from "@/components/Fields/DynField";
import Gauge from "@/components/Gauge";
import noUiSlider from "nouislider";
import "nouislider/distribute/nouislider.css";
export default {
  name: "Liste",
  components: { multiselect, VueInputMask, DynField, Gauge },
  data() {
    return {
      isBusy: true,
      items: [],
      itemsBackup: [],
      typeDemande: "",
      perPage: 10,
      currentPage: 1,
      totalItems: 0,
      can_filter: false,
      can_delete: false,
      can_read_dossier: false,
      can_dl_dossier: false,
      can_read_facture: false,
      can_create_dossier: false,
      can_export: false,
      sortBy: "id",
      sortDesc: true,
      table_type: "m0",
      ste_email: "",
      titlePage: this.$route.name,
      showFilter: true,
      exportProgress: false,
      periode: "",
      prixMinFocus: 0,
      prixMaxFocus: 0,
      date: {
        m0: {
          date: "",
          label: this.$i18n.t("30 derniers jours"),
          value: "m0",
        },
        m1: {
          date: "",
          label: "",
          value: "m1",
        },
        m2: {
          date: "",
          label: "",
          value: "m2",
        },
        all: {
          date: "",
          label: this.$i18n.t("Tous"),
          value: "all",
        },
      },
      fields: [
        { key: "reference", sortable: true },
        { key: "gestionnaire", sortable: true },
        { key: "adresse", sortable: true },
        { key: "ville", sortable: true },
        { key: "code_postal", sortable: true },
        {
          key:
            this.$route.path == "/evaluations" ? "estimation" : "type_document",
          sortable: true,
        },
        { key: "rapport", sortable: false },
        { key: "contact", sortable: false },
        { key: "actualisation", sortable: false },
      ],
      datas_def: {
        estimation_min: 0,
        estimation_max: 2000000,
      },
      forms: {
        gestionnaires: [],
        services: [],
        organisations: [],
        prestations: [],
        types_bien: [],
        statuts: [],
        prix: [0, 2000000],
        periode: {
          debut: "",
          fin: "",
          debut_dp: "",
          fin_dp: "",
        },
        reference: "",
        export: false,
      },
      options: {
        gestionnaires: [],
        services: [],
        organisations: [],
        prestations_test: [
          { id: "EVAL", text: this.$i18n.t("Evaluations Ooftop") },
          {
            id: "EXETR",
            text: this.$i18n.t("Evaluations Ooftop avec analyse"),
          },
          { id: "AVAL", text: this.$i18n.t("Avis de valeur") },
          { id: "EXIM", text: this.$i18n.t("Expertise immobilière") },
          { id: "DOCL", text: this.$i18n.t("Documents légaux") },
        ],
        prestations: [],
        types_bien: [
          { id: "Appartement", name: this.$i18n.t("Appartement") },
          { id: "Maison", name: this.$i18n.t("Maison") },
        ],
        statuts: [
          { id: -1, name: this.$i18n.t("En attente") },
          { id: 0, name: this.$i18n.t("Nouveau") },
          { id: 1, name: this.$i18n.t("En cours") },
          { id: 2, name: this.$i18n.t("Finalisé") },
          { id: 3, name: this.$i18n.t("Facturé") },
        ],
        debut: "",
        fin: "",
        reference: "",
        field_reference: {},
      },
    };
  },
  mounted() {
    this.get_data(0);
    this.maj_partner();
    let date = new Date();
    this.date.m0.date = date;
    let month = new Date().getMonth();
    let formatPrevMonth = new Date(date.setMonth(month - 1));
    let formatPrevMonth2 = new Date(date.setMonth(month - 2));
    this.date.m1.date = formatPrevMonth;
    this.date.m1.label =
      GetMonthName(formatPrevMonth.getMonth(), this.$i18n.t("months")) +
      " " +
      formatPrevMonth.getFullYear();
    this.date.m2.date = formatPrevMonth2;
    this.date.m2.label =
      GetMonthName(formatPrevMonth2.getMonth(), this.$i18n.t("months")) +
      " " +
      formatPrevMonth2.getFullYear();

    function GetMonthName(monthNumber, months) {
      return months[monthNumber];
    }
    var p = this;
    p.get_infos_cli();
    p.ste_email = p.infos_cli.partner.email;
    window.setTimeout(function() {
      p.ste_email = p.infos_cli.partner.email;
      for (let presta in p.options.prestations_test) {
        let testMenu = "menu_" + p.options.prestations_test[presta]["id"];
        if (p.infos_cli.menu.filter((e) => e.id == testMenu).length) {
          p.options.prestations_test[presta].text = p.$i18n.t(
            p.infos_cli.menu.filter((p) => p.id == testMenu)[0].title
          );
          p.options.prestations.push(p.options.prestations_test[presta]);
        }
      }
    }, 1000);

    axios
      .get(p.$apiUrl + "params/getFiltersParams", {
        params: { auth: p.auth_header() },
      })
      .then((response) => {
        if (response.data.error == "notlogged") {
          p.logout();
          p.$router.push({ path: "/" });
        } else {
          p.options.gestionnaires = response.data.gestionnaires;
          p.options.services = response.data.services;
          p.options.organisations = response.data.organisations;
          p.datas_def = response.data.datas_def;
          p.forms.prix = [
            p.datas_def.estimation_min,
            p.datas_def.estimation_max,
          ];
          if (p.$route.path != "/dataroom") {
            window.setTimeout(function() {
              var sliderPrix = document.getElementById("prix");
              if (sliderPrix) {
                if (!sliderPrix.noUiSlider) {
                  noUiSlider.create(sliderPrix, {
                    start: [p.forms.prix[0], p.forms.prix[1]],
                    connect: true,
                    step: 1,
                    range: {
                      min: p.datas_def.estimation_min,
                      max: p.datas_def.estimation_max,
                    },
                  });
                  sliderPrix.noUiSlider.on("update", function(values) {
                    p.forms.prix = values;
                  });
                }
              }
            }, 500);
          }
        }
      });
  },
  methods: {
    showFilterFt() {
      this.showFilter = !this.showFilter;
    },
    reset_data() {
      this.forms = {
        gestionnaires: [],
        services: [],
        organisations: [],
        prestations: [],
        types_bien: [],
        statuts: [],
        prix: [this.datas_def.estimation_min, this.datas_def.estimation_max],
        periode: {
          debut: "",
          fin: "",
          debut_dp: "",
          fin_dp: "",
        },
        reference: "",
      };
      this.reset_nui();
      this.get_data(1);
    },
    reset_nui() {
      var p = this;
      if (p.$route.path != "/dataroom") {
        var sliderPrix = document.getElementById("prix");
        if (sliderPrix) {
          if (sliderPrix.noUiSlider) sliderPrix.noUiSlider.destroy();
          noUiSlider.create(sliderPrix, {
            start: [p.forms.prix[0], p.forms.prix[1]],
            connect: true,
            range: {
              min: p.datas_def.estimation_min,
              max: p.datas_def.estimation_max,
            },
          });
          sliderPrix.noUiSlider.on("update", function(values) {
            p.forms.prix = values;
          });
        }
      }
    },
    get_gestionnaire(gid) {
      return gid &&
        gid > 0 &&
        this.options.gestionnaires &&
        this.options.gestionnaires.length &&
        this.options.gestionnaires.filter((p) => p.id == gid).length
        ? this.options.gestionnaires.filter((p) => p.id == gid)[0].name
        : gid;
    },
    maj_field_reference(field) {
      this.options.field_reference = field;
    },
    format_date_z(d, m, y) {
      return (
        (d < 10 ? "0" + String(d) : d) +
        "/" +
        (m < 10 ? "0" + String(m) : m) +
        "/" +
        y
      );
    },
    predefined_date(filtre) {
      this.table_type = filtre;
      if (filtre == "m0") {
        var d = new Date();
        var d30 = new Date();
        d30.setDate(d30.getDate() - 30);
        this.forms.periode.debut = this.format_date_z(
          d30.getDate(),
          d30.getMonth() + 1,
          d30.getFullYear()
        );
        this.forms.periode.fin = this.format_date_z(
          d.getDate(),
          d.getMonth() + 1,
          d.getFullYear()
        );
      }
      if (filtre == "m1") {
        var lastDayOfMonth = new Date(
          this.date.m1.date.getFullYear(),
          this.date.m1.date.getMonth() + 1,
          1
        );
        this.forms.periode.debut = this.format_date_z(
          1,
          this.date.m1.date.getMonth() + 1,
          this.date.m1.date.getFullYear()
        );
        this.forms.periode.fin = this.format_date_z(
          lastDayOfMonth.getDate(),
          lastDayOfMonth.getMonth() + 1,
          lastDayOfMonth.getFullYear()
        );
      }
      if (filtre == "m2") {
        var lastDayOfMonth = new Date(
          this.date.m2.date.getFullYear(),
          this.date.m2.date.getMonth() + 1,
          1
        );
        this.forms.periode.debut = this.format_date_z(
          1,
          this.date.m2.date.getMonth() + 1,
          this.date.m2.date.getFullYear()
        );
        this.forms.periode.fin = this.format_date_z(
          lastDayOfMonth.getDate(),
          lastDayOfMonth.getMonth() + 1,
          lastDayOfMonth.getFullYear()
        );
      }
      if (filtre == "all") {
        this.forms.periode.debut = "";
        this.forms.periode.fin = "";
      }
    },
    format_fields(fields) {
      var p = this;
      var f = [];
      if (fields) {
        fields.forEach(function(item) {
          var label = p.ucFirst(item);
          if (item == "reference") label = p.options.field_reference.libelle;
          if (item == "rapport" && p.get_first_route() === 'dataroom') label = "Action";
          if (item == "indice_confiance") label = "Indice de confiance";
          if (p.get_first_route() == "documents_legaux") {
            if (item == "adresse") label = "Sujet(s)";
            if (item == "estimation") label = "SPF interrogé";
          }
          if (p.get_first_route() == "dataroom") {
            if (item == "nb_line_todo") label = "Nombre de biens total";
            if (item == "nb_line_done") label = "Nombre de biens estimés";
            if (item == "nb_line_error") label = "Nombre d’erreurs";
          }
          label = p.$i18n.t(label);
          if (
            (p.get_first_route() != "dataroom" && item != "contact") ||
            (p.get_first_route() == "dataroom" &&
              item != "actualisation" &&
              item != "estimation" &&
              item != "type_de_bien")
          )
            f.push({
              key: item,
              label: label,
              sortable:
                item == "rapport" ||
                item == "contact" ||
                item == "actualisation"
                  ? false
                  : true,
            });
        });
      }
      return f;
    },
    ucFirst(str) {
      if (str.length > 0) {
        return (
          str[0].toUpperCase() +
          str
            .substring(1)
            .replace("_", " ")
            .replace("_", " ")
            .replace("_", " ")
        );
      } else {
        return str;
      }
    },
    onContextDate(type) {
      if (this.$i18n.locale == "fr" && type) {
        if (type == "fin" && this.forms.periode.fin_dp)
          this.forms.periode.fin = this.forms.periode.fin_dp
            .split("-")
            .reverse()
            .join("/");
        if (type == "debut" && this.forms.periode.debut_dp)
          this.forms.periode.debut = this.forms.periode.debut_dp
            .split("-")
            .reverse()
            .join("/");
      }
    },
    rapport(item, statut, type) {
      if (
        typeof this.can_read_dossier != "undefined" &&
        !this.can_read_dossier
      ) {
        this.infosModal(
          "warning",
          this.$i18n.t(
            "Vous n'avez pas les autorisations nécessaires pour accéder à cette page."
          ),
          false,
          "Informations"
        );
      } else {
        var pf = "/" + this.get_first_route();
        if (pf == "/") pf = "/" + type;
        switch (pf) {
          case "/evaluations":
            if (this.$route.path != pf + "/detail/" + item)
              this.$router.push({ path: pf + "/detail/" + item });
            break;
          default:
            switch (statut) {
              case 0:
                var etat = this.$i18n.t("Transfert en attente");
                var afficheRapport = 0;
                break;
              case 1:
                var etat = this.$i18n.t("Dossier en cours de traitement");
                var afficheRapport = 0;
                break;
              case 2:
                var etat = this.$i18n.t("Rapport disponible");
                var afficheRapport = 1;
                break;
              case 3:
                var etat = this.$i18n.t("Facture disponible");
                var afficheRapport = 1;
                break;
            }
            var messageRapport = this.$i18n.t(
              "La prestation est en cours de traitement : vous recevrez un email lorsque le rapport sera disponible."
            );
            if (afficheRapport)
              this.$router.push({ path: pf + "/detail/" + item });
            else
              this.infosModal("warning", messageRapport, false, "Informations");
            break;
        }
      }
    },
    supprimer(item, liste) {
      var p = this;
      var options = {
        title: "Suppression",
        size: "sm",
        buttonSize: "sm",
        okVariant: "warning",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0 fm",
        centered: true,
        cancelTitle: "X",
      };
      this.$bvModal
        .msgBoxConfirm(
          p.$i18n.t("Êtes-vous sur de vouloir supprimer n°") + item.id + " ?",
          options
        )
        .then((value) => {
          if (value) {
            urlAx = p.$apiUrl + "dataroom/supprimer/" + item.id;
            axios
              .get(urlAx, { params: { auth: p.auth_header() } })
              .then((response) => {
                if (response.data.error == "notlogged") {
                  p.logout();
                  p.$router.push({ path: "/" });
                }
                if (response.data.error) {
                  p.show_alert("warning", response.data.error);
                } else {
                  if (response.data.datas) {
                    p.show_alert("success", p.$i18n.t("Dossier supprimé"));
                    liste.splice(liste.indexOf(item), 1);
                  } else {
                    p.show_alert(
                      "warning",
                      p.$i18n.t("Une erreur est survenue")
                    );
                  }
                }
              })
              .catch((error) => {});
          }
        });
    },
    get_doc(typeD, id) {
      var type = this.get_first_route();
      var typeR = "demandes";
      if (type == "dataroom") typeR = "dataroom";
      window.open(
        this.$apiUrl +
          typeR +
          "/getDoc/" +
          typeD +
          "/" +
          id +
          "?auth=" +
          JSON.stringify(this.auth_header())
      );
    },
    get_data(changePage) {
      var p = this;
      if (changePage == 1) p.currentPage = 1;
      p.forms.export = changePage == -1;
      if (p.forms.export) p.exportProgress = true;
      else {
        p.items = [];
        p.fields = [];
        p.typeDemande = "";
        p.isBusy = true;
      }
      var type = p.get_first_route();
      if (type == "") type = "all";
      var urlAx = p.$apiUrl + "demandes/liste/" + type;
      if (p.forms.periode.debut.length != 10) p.forms.periode.debut = "";
      if (p.forms.periode.fin.length != 10) p.forms.periode.fin = "";
      if (type == "dataroom") urlAx = p.$apiUrl + "dataroom/liste";
      axios
        .get(urlAx, {
          params: {
            auth: p.auth_header(),
            recherche: p.forms.reference,
            filters: p.forms,
            limit: p.forms.export ? 10000 : p.perPage,
            startLine:
              p.currentPage == 1 || p.forms.export
                ? 0
                : (p.currentPage - 1) * p.perPage,
          },
        })
        .then((response) => {
          if (response.data.error == "notlogged") {
            p.logout();
            p.$router.push({ path: "/" });
          }
          if (p.forms.export) p.exportProgress = false;
          if (response.data.excel) {
            window.open(
              this.$apiUrl +
                "demandes/exportExcel/" +
                response.data.excel +
                "?auth=" +
                JSON.stringify(this.auth_header())
            );
          } else {
            p.can_filter = response.data.can_filter;
            p.can_delete = response.data.can_delete;
            p.can_read_dossier = response.data.can_read_dossier;
            p.can_create_dossier = response.data.can_create_dossier;
            p.can_dl_dossier = response.data.can_dl_dossier;
            p.can_read_facture = response.data.can_read_facture;
            p.can_export = response.data.can_export;
            if (response.data.datas) {
              p.items = response.data.datas;
              p.itemsBackup = response.data.datas;
              p.fields = response.data.fields;
              p.typeDemande = response.data.typeDemande;
              p.totalItems = response.data.total;
              p.isBusy = false;
              var $ = (window.jQuery = require("jquery"));
              $(function() {
                $(document).ready(function() {
                  window.setInterval(function() {
                    $(".rapport:not(.init)")
                      .unbind("click")
                      .on("click", function() {
                        p.rapport(
                          $(this).data("id"),
                          $(this).data("statut"),
                          $(this).data("type")
                        );
                      });
                    $(".facturePDF:not(.init)")
                      .unbind("click")
                      .on("click", function() {
                        window.open(
                          p.$apiUrl +
                            "demandes/getDoc/facture/" +
                            $(this).data("id") +
                            "?auth=" +
                            JSON.stringify(p.auth_header())
                        );
                      });
                    $(".rapportPDF:not(.init)")
                      .unbind("click")
                      .on("click", function() {
                        if (
                          $(this).data("type") == "evaluations" &&
                          $(this).data("statut") > 1
                        )
                          window.open(
                            p.$apiUrl +
                              "demandes/rapport/" +
                              $(this).data("id") +
                              "?auth=" +
                              JSON.stringify(p.auth_header())
                          );
                        else
                          p.rapport(
                            $(this).data("id"),
                            $(this).data("statut"),
                            $(this).data("type")
                          );
                      });
                    $(
                      ".listing tbody tr > td:not(:last-child):not(:nth-last-child(2)):not(:nth-last-child(3)):not(.init)"
                    )
                      .unbind("click")
                      .on("click", function() {
                        var trlb = $(this).closest("tr");
                        p.rapport(
                          trlb.find(".rapportPDF").data("id"),
                          trlb.find(".rapportPDF").data("statut"),
                          trlb.find(".rapportPDF").data("type")
                        );
                      });
                    $(
                      ".rapport:not(.init),.facturePdf:not(.init),.rapportPDF:not(.init),.listing tbody tr > td:not(:last-child):not(:nth-last-child(2)):not(:nth-last-child(3)):not(.init)"
                    ).addClass("init");
                  }, 2500);
                });
              });
            } else {
              //p.show_alert("warning","Pas de données disponible");
              p.isBusy = false;
            }
          }
        })
        .catch((error) => {});
    },
    date_to_local(date) {
      date = date.split(" ");
      if (date.length > 1) {
        var heure = date[1];
      } else {
        var heure = "";
      }
      date = date[0].split("/");
      const event = new Date(Date.UTC(date[2], date[1] - 1, date[0], 0, 0, 0));
      const options = { year: "numeric", month: "long", day: "numeric" }; // weekday: 'long',
      return (
        event.toLocaleDateString(
          this.$i18n.locale == "fr" ? "fr-FR" : "en-US",
          options
        ) + (this.$i18n.locale == "fr" && heure != "" ? " à " + heure : "")
      );
    },
    trad_type(type) {
      if (this.$i18n.locale == "fr") return type;
      else {
        if (type.indexOf(" - ") > 1) {
          type = type.split(" - ");
          return this.$i18n.t(type[0]) + " - " + type[1];
        } else return this.$i18n.t(type);
      }
    },
    trad_adresse(adresse) {
      if (this.$i18n.locale == "fr") return adresse;
      else {
        return adresse
          .replace(
            "Personne(s) physique(s)",
            this.$i18n.t("Personne(s) physique(s)")
          )
          .replace(
            "Personne(s) morale(s)",
            this.$i18n.t("Personne(s) morale(s)")
          )
          .replace("Document(s)", this.$i18n.t("Document(s)"))
          .replace("Zone(s)", this.$i18n.t("Zone(s)"));
      }
    },
    trad_prestation(presta) {
      if (this.$i18n.locale == "fr") return presta;
      else {
        presta = this.$i18n.t(presta);
        if (presta.indexOf(" et ") > 1) {
          presta = presta.split(" et ");
          for (var i = 0; i < presta.length; i++)
            presta[i] = this.$i18n.t(presta[i]);
          presta = presta.join(", ");
        }
        if (presta.indexOf(", ") > 1) {
          presta = presta.split(", ");
          for (var i = 0; i < presta.length; i++)
            presta[i] = this.$i18n.t(presta[i]);
          presta = presta.join(", ");
        }
        return presta;
      }
    },
    isNumber(evt) {
      const keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ".",
      ];
      const keyPressed = evt.key;
      if (keyPressed == "Enter") {
        this.prixMinFocus = 0;
        this.prixMaxFocus = 0;
        this.reset_nui();
      }
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  watch: {
    currentPage: function(newVal, oldVal) {
      this.get_data(0);
    },
  },
};
</script>
